import React, {useEffect} from 'react';
import FormInput from "../../../Components/Forms/FormInput";
import {SOURCE_OF_FUNDS_OPTIONS} from "../../../constants";

const Details = (props) => {
    const {
        data = {
            'bank_name':                '',
            'account_holder_name':      '',
            'sort_code':                '',
            'account_number':           '',
            'source_of_funds_select':   '',
            'source_of_funds_other':    '',
            'source_of_funds':          '',
        },
        errors      = null,
        onChange    = (field, value) => {},
        disabled    = false
    } = props;

    useEffect(() => {
        if (data.source_of_funds_select !== 'Other') {
            onChange('source_of_funds_other', '');
        }
    }, [data.source_of_funds_select]);

    if (data.source_of_funds_other) {
        data.source_of_funds = data.source_of_funds_other;
    } else {
        data.source_of_funds = data.source_of_funds_select;
    }

    return (
        <React.Fragment>
            <div className={'row m-0 p-0'}>
                <div className={'col-12 col-md-6 m-0 p-0 pe-md-2'}>
                    <FormInput
                        required={true}
                        name={'bank_name'}
                        detailedLabel={'Bank name'}
                        value={data.bank_name}
                        type={'text'}
                        onChange={(value) => onChange('bank_name', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 ps-md-2'}>
                    <FormInput
                        required={true}
                        name={'account_holder_name'}
                        detailedLabel={'Account holder name'}
                        value={data.account_holder_name}
                        type={'text'}
                        onChange={(value) => onChange('account_holder_name', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 pe-md-2'}>
                    <FormInput
                        required={true}
                        name={'sort_code'}
                        detailedLabel={'Sort code'}
                        value={data.sort_code}
                        type={'sortcode'}
                        onChange={(value) => onChange('sort_code', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 ps-md-2'}>
                    <FormInput
                        required={true}
                        name={'account_number'}
                        detailedLabel={'Account number'}
                        value={data.account_number}
                        type={'accountnumber'}
                        onChange={(value) => onChange('account_number', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 pe-md-2'}>
                    <FormInput
                        required={true}
                        name={'source_of_funds_select'}
                        detailedLabel={'Source of funds'}
                        value={data.source_of_funds_select}
                        type={'select'}
                        options={SOURCE_OF_FUNDS_OPTIONS}
                        onChange={(value) => onChange('source_of_funds_select', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                {data.source_of_funds_select === 'Other' ? (
                    <div className={'col-12 col-md-6 m-0 p-0 ps-md-2'}>
                        <FormInput
                            required={true}
                            name={'source_of_funds_other'}
                            detailedLabel={'Enter source of funds'}
                            value={data.source_of_funds_other}
                            type={'text'}
                            onChange={(value) => onChange('source_of_funds_other', value)}
                            disabled={disabled}
                            error={errors}
                        />
                    </div>
                ) : null }
            </div>
        </React.Fragment>
    );
}

export default Details;
